import { setLang } from './lang'

export * from './lang'

setLang()
